import React from 'react';
import './Projects.css';
import ManPower from '../../images/projects/ManPower.PNG';
import DukanGhor from '../../images/projects/Dukanghor.PNG';
import Foodwala from '../../images/projects/foodwalapng.png';
import Shopping from '../../images/projects/ShoppingCart.png';
import Superstar from '../../images/projects/superstarpng.png';
import ImageSlider from '../../images/projects/imageslider.png';
import HurryUp from '../../images/projects/hurryup.png';
import CookingMaster from '../../images/projects/cookingMaster.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import BubblesParticlesBackground from '../ParticlesBackground/BubblesParticlesBackground';

const projectsData = [
    {
        id: 1,
        name: 'Man Power Supply Company',
        description: 'An authenticated user can order a service and check his order history and also give reviews. Admin can add new services and add new admin if needed. Admin can see all the orders and can change the status of order.',
        banner: ManPower,
        technologyUsed: ['React.js', 'Node.js', 'MongoDB', 'Stripe.js', 'Express.js', 'Firebase'],
        github: 'https://github.com/imsamrat/ManPower-Supply-Agency',
        website: 'https://creative-agency247.web.app',
        projectCategory: 'full-stack'
    }, {
        id: 2,
        name: 'DukanGhor',
        description: 'A simple, static and one-page e-commerce website design. Admin can add products and delete items. Customers can view their previous orders.',
        banner: DukanGhor,
        technologyUsed: ['React.js', 'Node.js', 'Express.js', 'MongoDB', 'Firebase', 'Bootstrap'],
        github: 'https://github.com/imsamrat/DukanGhor-Shop',
        website: 'https://dukanghor-shop.web.app/',
        projectCategory: 'full-stack'
    }, {
        id: 3,
        name: 'Foodwala-An Online Food Delivery Web App',
        description: 'A single page responsive restaurant web application.Food items are categorized and use can order their required food.An authenticated user can processed checkout with their delivery address.',
        banner: Foodwala,
        technologyUsed: ['React.js', 'Firebase', 'React Router', 'Bootstrap', 'HTML', 'CSS', 'JavaScript'],
        github: 'https://github.com/imsamrat/foodwala',
        website: 'https://foodwala24.web.app/',
        projectCategory: 'react'
    },{
        id: 4,
        name: 'The Super Star League – React App',
        description: 'Responsive React project to get Update about English Premier League.This is a fully responsive react app with dynamic Routing system.',
        banner: Superstar,
        technologyUsed: ['React.js', 'Bootstrap', 'CSS', 'Rest API'],
        github: 'https://github.com/imsamrat/The-Superster-League',
        website: 'https://friendly-shaw-3cdec8.netlify.app/',
        projectCategory: 'react'
    },{
        id: 5,
        name: 'HurryUp Riders – React App',
        description: 'There is some vehicles loaded from fake data. User can choose any vehicle of his choice.-	There is an authentication system so that any anonymous user can’t access another user’s information.',
        banner: HurryUp,
        technologyUsed: ['React.js', 'Firebase', 'ES6', 'Bootstrap'],
        github: 'https://github.com/imsamrat/HurryUp-Riders',
        website: 'https://assignment-aut.web.app/',
        projectCategory: 'react'
    },{
        id: 6,
        name: 'Image Slider ',
        description: 'I’ve used a third party API from the internet to grab the information into my website.Users can search image and select image.Users can set time duration.',
        banner: ImageSlider,
        technologyUsed: ['HTML', 'CSS', 'Bootstrap', 'JavaScript'],
        github: 'https://github.com/imsamrat/Image-Slider',
        website: 'https://imsamrat.github.io/Image-Slider/',
        projectCategory: 'simple'
    },{
        id: 7,
        name: 'Cooking Master ',
        description: 'I’ve used a third party API from the internet to grab the information into my website. Searching a food by its name and showing the results. Clicking a specific food item, showing all the ingredients of that food item.',
        banner: CookingMaster,
        technologyUsed: ['HTML', 'CSS', 'Bootstrap', 'JavaScript', 'Rest API'],
        github: 'https://github.com/imsamrat/Cooking-Master',
        website: 'https://imsamrat.github.io/Cooking-Master/?#',
        projectCategory: 'simple'
    },{
        id: 8,
        name: 'Shopping Cart',
        description: 'A simple, static and one-page Shopping Cart design. Customers can increase product quantity and automatically price will be changed.',
        banner: Shopping,
        technologyUsed: ['HTML', 'CSS', 'JavaScript'],
        github: 'https://github.com/imsamrat/shopping-cart',
        website: 'https://imsamrat.github.io/shopping-cart/',
        projectCategory: 'simple'
    }
]

const Projects = () => {

    const handleProjectFilter = (e) => {
        const filterContainer = document.querySelector('.projects-filter');
        const projectsItems = document.querySelectorAll('.projects-box');
        const totalProjectsItem = projectsItems.length;
        filterContainer.querySelector('.active').classList.remove('active');
        e.target.classList.add('active');

        const filterValue = e.target.getAttribute('project-filter');
        for (let k = 0; k < totalProjectsItem; k++) {
            if (filterValue === projectsItems[k].getAttribute('project-category')) {
                projectsItems[k].classList.remove('hide');
                projectsItems[k].classList.add('show');
            }
            else {
                projectsItems[k].classList.remove('show');
                projectsItems[k].classList.add('hide');
            }
            if (filterValue === 'all') {
                projectsItems[k].classList.remove('hide');
                projectsItems[k].classList.add('show');
            }

        }
    };


    return (
        <>
            <div className="particles-bg">
                {/* <BubblesParticlesBackground /> */}
            </div>
            <section id="projects" className="projects section">
                <div className="container">
                    <div className="row">
                        <div className="section-title padd-15">
                            <h2>Projects</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="projects-filter padd-15">
                            <button onClick={handleProjectFilter} type="button" className="active" project-filter="all">All</button>
                            <button onClick={handleProjectFilter} type="button" project-filter="react">React</button>
                            <button onClick={handleProjectFilter} type="button" project-filter="full-stack">Full Stack</button>
                            <button onClick={handleProjectFilter} type="button" project-filter="simple">Simple</button>
                        </div>
                    </div>
                    <div className="row">
                        {
                            projectsData.map(project => <div key={project.id} className="projects-box padd-15" project-category={project.projectCategory}>
                                <div className="projects-item shadow-dark">
                                    <div className="projects-img">
                                        <img src={project.banner} alt="projects" />
                                    </div>
                                    <div className="projects-info">
                                        <h2>{project.name}</h2>
                                        <p className="description">{project.description}</p>
                                        <p className="technology-used">
                                            {
                                                project.technologyUsed.map((technology, index) => <span key={index}>{technology}</span>)
                                            }
                                        </p>

                                        <div className="icon">
                                            <a href={project.github} rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faGithub} /> Code</a>
                                            <a href={project.website} rel="noreferrer" target="_blank"><FontAwesomeIcon icon={faExternalLinkAlt} /> Live</a>
                                        </div>

                                    </div>
                                </div>
                            </div>)
                        }

                    </div>
                    {/* <h1 style={{textAlign: 'center', color:"red", margin: '50px'}}>Some more projects will be added very soon :)</h1> */}
                </div>
            </section>
        </>
    );
};

export default Projects;